import { Component, Input, OnInit } from '@angular/core';
import { Browser } from '@capacitor/browser';
import { NavController } from '@ionic/angular';
import { placeholder } from 'src/app/models/placeholder';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'banner-carousel',
  templateUrl: './banner-carousel.component.html',
  styleUrls: ['./banner-carousel.component.scss'],
})
export class BannerCarouselComponent implements OnInit {
  @Input() showButton: boolean;
  @Input() showLabel: boolean;
  @Input() bannerList: any[];
  public slideOpts: any;
  public imagePlaceholder = placeholder;
  constructor(
    private navControl: NavController,
    private analyticsService: AnalyticsService
  ) {
    this.showLabel = true;
    this.showButton = true;
    this.slideOpts = {
      freeMode: true,
      passiveListeners: true,
      slidesPerView: 1.3,
    };
  }
  ngOnInit() { }
  ionViewDidEnter() { }
  async routeTo(itemData) {
    const link = itemData.redirectURL || itemData.landing_url || itemData.link;
    if (link) {
      if (itemData.banner_type && itemData.banner_type === 'internal_url') {
        this.navControl.navigateForward([decodeURIComponent(link)]);
        this.analyticsService.trackUnified('banner_carousel_clicked', {
          flow: 'shared',
          outcome: 'success',
          legacy_event_name: 'banner_carousel_clicked',
          component: 'banner-carousel-component',
          button: decodeURIComponent(link),
        });
      } else {
        this.analyticsService.trackUnified('banner_carousel_clicked', {
          flow: 'shared',
          outcome: 'success',
          legacy_event_name: 'banner_carousel_clicked',
          component: 'banner-carousel-component',
          button: link,
        });
        await Browser.open({ url: link });
        window.location.href = link;
      }
    }
  }
}
